__turbopack_context__.v({
  "column": "FanStories-module-scss-module__aqYF1q__column",
  "copy": "FanStories-module-scss-module__aqYF1q__copy",
  "fade-in": "FanStories-module-scss-module__aqYF1q__fade-in",
  "header": "FanStories-module-scss-module__aqYF1q__header",
  "headline": "FanStories-module-scss-module__aqYF1q__headline",
  "image": "FanStories-module-scss-module__aqYF1q__image",
  "image1": "FanStories-module-scss-module__aqYF1q__image1",
  "image2": "FanStories-module-scss-module__aqYF1q__image2",
  "images": "FanStories-module-scss-module__aqYF1q__images",
  "inner": "FanStories-module-scss-module__aqYF1q__inner",
  "isInView": "FanStories-module-scss-module__aqYF1q__isInView",
  "loadMore": "FanStories-module-scss-module__aqYF1q__loadMore",
  "lockup": "FanStories-module-scss-module__aqYF1q__lockup",
  "masonry": "FanStories-module-scss-module__aqYF1q__masonry",
  "root": "FanStories-module-scss-module__aqYF1q__root",
  "stories": "FanStories-module-scss-module__aqYF1q__stories",
  "termsContainer": "FanStories-module-scss-module__aqYF1q__termsContainer",
  "termsText": "FanStories-module-scss-module__aqYF1q__termsText",
});
